import { createSelector } from 'reselect'

//Constants
export const FETCH_BRANDS_REPORT_REQUEST = 'opinary/FETCH_BRANDS_REPORT_REQUEST'
export const FETCH_BRANDS_REPORT_SUCCESS = 'opinary/FETCH_BRANDS_REPORT_SUCCESS'
export const CHANGE_METRIC = 'opinary/CHANGE_METRIC'
// Root Selector
export const getRoot = state => state

export const getReport = createSelector(
  getRoot,
  ({ report }) => report.data || null
)

export const getLoadingState = createSelector(
  getRoot,
  ({ report }) => report.isloading || false
)

export const getCurrentMetric = createSelector(
  getRoot,
  ({ report }) => report.metric || 'impressions'
)

//Actions
export const fetchBrandsReport = date => ({
  type: FETCH_BRANDS_REPORT_REQUEST,
  payload: date,
})

export const changeMetric = metric => ({
  type: CHANGE_METRIC,
  payload: metric,
})

const initalState = {
  isloading: false,
  metric: 'impressions',
}

const report = (state = initalState, action) => {
  switch (action.type) {
    case FETCH_BRANDS_REPORT_REQUEST:
      return {
        ...state,
        isloading: true,
      }

    case CHANGE_METRIC:
      return {
        ...state,
        metric: action.payload,
      }
    case FETCH_BRANDS_REPORT_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isloading: false,
      }
    default:
      return state
  }
}

export default report



// WEBPACK FOOTER //
// ./src/stores/report/index.js